import './src/global.scss';

import React from 'react';
import { GlobalLocalizationProvider, PageLocalizationProvider } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { LocationProvider } from '@reach/router';

import { ServicesContextProvider, MagentoStoreProvider, MagentoCustomerProvider, MagentoAPIProvider  } from '@sbi-international/boutik.gatsby.plugin.services';

import { FeedbackProvider } from './src/contexts/feedback/FeedbackProvider';
import { FeedbackProviderWrapper } from './src/contexts/feedback/FeedbackProviderWrapper';
import { InteractionProvider } from './src/contexts/InteractionProvider';

import { CartContextProvider } from '@sbi-international/boutik.gatsby.plugin.checkout';

import { cookieConsentConfig } from './cookieConsentConfig';
import { CookiesConsentProvider } from '@sbi-international/boutik.package.cookie.consent';

export const wrapRootElement = ({ element }, { magentoBackend }) => {
    const isBrowser = typeof window !== 'undefined';
    const apiBase = typeof window !== 'undefined' ? window.location?.origin : null;

    return (
        <GlobalLocalizationProvider>
            <LocationProvider>
                <FeedbackProvider>
                    <MagentoAPIProvider magentoUrl={apiBase || magentoBackend}>
                        <ServicesContextProvider magentoUrl={apiBase || magentoBackend}>
                            <FeedbackProviderWrapper>
                                {isBrowser ? (
                                    <CookiesConsentProvider config={cookieConsentConfig}>
                                        <InteractionProvider>{element}</InteractionProvider>
                                    </CookiesConsentProvider>
                                ) : (
                                    <InteractionProvider>{element}</InteractionProvider>
                                )}
                            </FeedbackProviderWrapper>
                        </ServicesContextProvider>
                    </MagentoAPIProvider>
                </FeedbackProvider>
            </LocationProvider>
        </GlobalLocalizationProvider>
    );
};

export const wrapPageElement = ({ element, props: { pageContext } }) => {
    return (
        <PageLocalizationProvider pageContext={pageContext}>
            <MagentoStoreProvider key={pageContext.locale}>
                <MagentoCustomerProvider>
                    <CartContextProvider>{element}</CartContextProvider>
                </MagentoCustomerProvider>
            </MagentoStoreProvider>
        </PageLocalizationProvider>
    );
};